<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else forgotUserNameFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="forgotUserNameFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #forgotUserNameFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing">
    <div
      *ngIf="isBrowserIE && media.isActive('lt-md'); else forgotUserNameMessagesFlexColumnTemplate"
      [ngClass]="{ 'ie-display': isBrowserIE }"
    >
      <ng-container *ngTemplateOutlet="forgotUserNameMessagesFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else forgotUserNameMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="forgotUserNameMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #forgotUserNameMessagesFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <!-- Instruction Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showInstructionMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showInstructionMessagesSpinner && this.instructionMessageList.length > 0"
  >
    <div
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="extra-large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.instructionMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #forgotUserNameMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else forgotUserNameFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="forgotUserNameFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #forgotUserNameFormFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@forgot-user-name.form.title">forgot-user-name.form.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div class="display-text">
      <ng-container *ngTemplateOutlet="forgotUserNameFormPart1FlexColumnTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="forgotUserNameFormPart2FlexColumnTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #forgotUserNameFormPart1FlexColumnTemplate>
  <form [formGroup]="forgotUserNameFormPart1">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.social-security-number.placeholder"
            placeholder="forgot-user-name.form.social-security-number.placeholder"
            type="text"
            [formControl]="socialSecurityNumberFormControl"
            autocomplete="off"
            [maxlength]="fieldValidations.userRegistration.socialSecurityNumberMaxLength"
            required
            onkeypress="return isNumberKey(this, event, 0)"
          />
          <mat-hint align="end" i18n="@@forgot-user-name.form.hint.social-security-number"
            >forgot-user-name.form.hint.social-security-number</mat-hint
          >
          <mat-error *ngIf="socialSecurityNumberFormControl.hasError('required')" i18n="@@forgot-user-name.form.error.required"
            >forgot-user-name.form.error.required</mat-error
          >
          <mat-error
            *ngIf="
              (socialSecurityNumberFormControl.hasError('minlength') || socialSecurityNumberFormControl.hasError('maxlength')) &&
              !socialSecurityNumberFormControl.hasError('required')
            "
            i18n="@@forgot-user-name.form.error.social-security-number"
            >forgot-user-name.form.error.social-security-number</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.social-security-number.placeholder"
            placeholder="forgot-user-name.form.social-security-number.placeholder"
            type="text"
            [value]="maskSocialSecurityNumber(forgotUserNameInfo.ssn)"
            autocomplete="off"
            readonly
            disabled
          />
          <mat-icon matSuffix>done</mat-icon>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.last-name.placeholder"
            placeholder="forgot-user-name.form.last-name.placeholder"
            type="text"
            [formControl]="lastNameFormControl"
            autocomplete="family-name"
            [maxlength]="fieldValidations.userRegistration.lastNameMaxLength"
            required
          />
          <mat-error *ngIf="lastNameFormControl.hasError('required')" i18n="@@forgot-user-name.form.error.required"
            >forgot-user-name.form.error.required</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.last-name.placeholder"
            placeholder="forgot-user-name.form.last-name.placeholder"
            type="text"
            [value]="forgotUserNameInfo.lastName"
            autocomplete="off"
            readonly
            disabled
          />
          <mat-icon matSuffix>done</mat-icon>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.date-of-birth.placeholder"
            placeholder="forgot-user-name.form.date-of-birth.placeholder"
            [formControl]="dateOfBirthFormControl"
            autocomplete="bday"
            [min]="fieldValidationsDateOfBirthMinValue"
            [max]="fieldValidationsDateOfBirthMaxValue"
            [matDatepicker]="dateOfBirthPicker"
            onkeypress="return isDateKey(this, event, true, false)"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateOfBirthPicker></mat-datepicker>
          <mat-hint align="end" i18n="@@forgot-user-name.form.hint.date-of-birth">forgot-user-name.form.hint.date-of-birth</mat-hint>
          <mat-error *ngIf="dateOfBirthFormControl.hasError('required')" i18n="@@forgot-user-name.form.error.date-of-birth.required"
            >forgot-user-name.form.error.date-of-birth.required</mat-error
          >
          <mat-error *ngIf="dateOfBirthFormControl.hasError('matDatepickerMin') && !dateOfBirthFormControl.hasError('required')">
            <span i18n="@@forgot-user-name.form.error.date-of-birth.min">forgot-user-name.form.error.date-of-birth.min</span>
            {{ fieldValidationsDateOfBirthMinValue | date: 'MM/dd/yyyy' }}</mat-error
          >
          <mat-error *ngIf="dateOfBirthFormControl.hasError('matDatepickerMax') && !dateOfBirthFormControl.hasError('required')">
            <span i18n="@@forgot-user-name.form.error.date-of-birth.max">forgot-user-name.form.error.date-of-birth.max</span>
            {{ fieldValidationsDateOfBirthMaxValue | date: 'MM/dd/yyyy' }}</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="userVerified">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.date-of-birth.placeholder"
            placeholder="forgot-user-name.form.date-of-birth.placeholder"
            [value]="forgotUserNameInfo.birthDate"
            autocomplete="off"
            [matDatepicker]="dateOfBirthPicker"
            readonly
            disabled
          />
          <mat-icon matSuffix>done</mat-icon>
          <mat-datepicker #dateOfBirthPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing"
        *ngIf="!userVerified"
      >
        <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required></re-captcha>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing" *ngIf="!userVerified">
        <button
          mat-flat-button
          color="primary"
          (click)="verifyUser()"
          [disabled]="!verifyEnabled()"
          i18n="@@forgot-user-name.form.verify-button.label"
        >
          forgot-user-name.form.verify-button.label
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showVerifyUserSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showVerifyError"
      >
        <b><span i18n="@@forgot-user-name.verify-message.error.1">forgot-user-name.verify-message.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showVerifyError"
      >
        <b><span i18n="@@forgot-user-name.verify-message.error.2">forgot-user-name.verify-message.error.2</span></b>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #forgotUserNameFormPart2FlexColumnTemplate>
  <form [formGroup]="forgotUserNameFormPart2">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-pre-spacing" *ngIf="userVerified">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@forgot-user-name.form.email-address.placeholder"
            placeholder="forgot-user-name.form.email-address.placeholder"
            type="email"
            autocomplete="off"
            [value]="forgotUserNameInfo.homeEmail"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text normal-paragraph-spacing"
        *ngIf="userVerified && !showLoginButton"
      >
        <b><span i18n="@@forgot-user-name.pre-submit-message.1">forgot-user-name.pre-submit-message.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing"
        *ngIf="userVerified && !showSubmitSpinner && !showLoginButton"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="submitUser()"
          i18n="@@forgot-user-name.form.submit-button.label"
          [disabled]="!submitEnabled()"
          *ngIf="validacctusser"
        >
          forgot-user-name.form.submit-button.label
        </button>
        <button mat-flat-button color="primary" (click)="registerUser()" i18n="@@login.form.register-button.label" *ngIf="registerVisible && !showSubmitError2">
            login.form.register-button.label
        </button>
        &nbsp;&nbsp;
        <button mat-stroked-button color="primary" (click)="resetForm()" i18n="@@forgot-user-name.form.reset-button.label">
          forgot-user-name.form.reset-button.label
        </button>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSubmitSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showSubmitError" >
        <b><span i18n="@@forgot-user-name.submit-message.error.1">forgot-user-name.submit-message.error.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showSubmitError"
      >
        <b><span i18n="@@forgot-user-name.submit-message.error.2">forgot-user-name.submit-message.error.2</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showSubmitError2" >
        <b><span i18n="@@forgot-user-name.submit-message.error.3">forgot-user-name.submit-message.error.3</span></b>
      </div>
      <!-- <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showSubmitError2" >
        <b><span i18n="@@forgot-user-name.submit-message.error.4">forgot-user-name.submit-message.error.4</span></b>
      </div>-->
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showLoginButton"
      >
        <b><span i18n="@@forgot-user-name.submit-message.success.1">forgot-user-name.submit-message.success.1</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showLoginButton"
      >
        <b><span i18n="@@forgot-user-name.submit-message.success.2">forgot-user-name.submit-message.success.2</span></b>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing" *ngIf="showLoginButton">
        <button mat-flat-button color="primary" (click)="openLogin()" i18n="@@forgot-user-name.form.login-button.label">
          forgot-user-name.form.login-button.label
        </button>
      </div>
    </div>
  </form>
</ng-template>
